(function () {
    'use strict';

    function AdminCtrl(restangular) {
        var vm = this;
    };

    angular
        .module('app')
        .controller('AdminCtrl', ['Restangular', AdminCtrl]);

})();